import { ApiClient } from '../../core/api/ApiClient';
import { API_BASE_URL } from '../../core/config/api';
import LogUtil from '../../core/utils/LogUtil';
import { PrescriptionRepositoryImpl } from './implementations';
import { PrescriptionService } from './services';

// Prescription Domain Exports
export * from './implementations';
export * from './interfaces';
export * from './services';

/**
 * Prescription Domain Dependency Injection Container
 * 의존성 주입을 통한 클린 아키텍처 구현
 */
class PrescriptionDomainContainer {
  constructor() {
    this._apiClient = null;
    this._prescriptionRepository = null;
    this._prescriptionService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      this._apiClient = new ApiClient(API_BASE_URL);
      LogUtil.log('🔧 [Prescription Container] ApiClient 초기화 완료:', API_BASE_URL);
    }
    return this._apiClient;
  }

  get prescriptionRepository() {
    if (!this._prescriptionRepository) {
      this._prescriptionRepository = new PrescriptionRepositoryImpl(
        this.apiClient
      );
      LogUtil.log(
        '🔧 [Prescription Container] PrescriptionRepositoryImpl 초기화 완료'
      );
    }
    return this._prescriptionRepository;
  }

  get prescriptionService() {
    if (!this._prescriptionService) {
      this._prescriptionService = new PrescriptionService(
        this.prescriptionRepository
      );
      LogUtil.log(
        '🔧 [Prescription Container] PrescriptionService 초기화 완료'
      );
    }
    return this._prescriptionService;
  }

  /**
   * 컨테이너 초기화 (테스트용)
   */
  reset() {
    this._apiClient = null;
    this._prescriptionRepository = null;
    this._prescriptionService = null;
  }
}

// Singleton 인스턴스
const container = new PrescriptionDomainContainer();

/**
 * Prescription Service 싱글톤 접근자
 * @returns PrescriptionService 인스턴스
 */
export const getPrescriptionService = () => container.prescriptionService;

/**
 * Prescription Repository 싱글톤 접근자 (테스트용)
 * @returns PrescriptionRepositoryImpl 인스턴스
 */
export const getPrescriptionRepository = () => container.prescriptionRepository;

/**
 * 컨테이너 리셋 (테스트용)
 */
export const resetPrescriptionContainer = () => container.reset();
